import { createContext, useContext, useEffect, useState } from "react";
const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lb_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("lb_cart", JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      const price = product.discount_price || product.price;
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, { product_id: product.id, name: product.name, price, image: product.images?.[0], quantity: qty, stock: product.stock }];
    });
    setOpen(true);
  };
  const update = (pid, qty) => setItems((p) => p.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  const remove = (pid) => setItems((p) => p.filter((i) => i.product_id !== pid));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
